import { parse } from 'query-string';
import { PERFORMANCE_METRICS_TOGGLES, jobNames } from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_PERFORMANCE_JOB,
  RESET_PERFORMANCE_PAGE
} from './../actions';

const initialState = {
  performanceMetricsInfo: {
    toggles: 15,
    buildFilter: '',
    nodes: ['all'],
    caseName: '',
    action: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.PERFORMANCE
  },
  selectedJobs: []
};

const performanceMetricsPage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PERFORMANCE_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case RESET_PERFORMANCE_PAGE:
      return initialState;
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/performance-metrics') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // n: nodes
      // c: selected case name
      // a: selected action
      // j: given job number, used to highlight a job coming from another page
      // d: id for selected dispatcher
      // The names need to be short because they're part of the URL query.
      const { f, n, c, a, t, j, d } = parse(action.payload.search);

      const parsePerformanceMetricsInfo = (
        toggles,
        buildFilter,
        nodes,
        caseName,
        action,
        givenJob,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(j);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 15) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          nodes: nodes ?
            Array.isArray(nodes) ? nodes : [nodes] :
            [],
          caseName: caseName ? caseName : '',
          action: action ? action : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parsePerformanceMetricsInfo(t, f, n, c, a, j, d, state.performanceMetricsInfo);
      return {
        ...state,
        performanceMetricsInfo: parsedInfo,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}` }] :
          []
      };

    default:
      return state;
  }
};

export default performanceMetricsPage;

const getPerformanceMetricsPage = state => state.performanceMetricsPage;
export const getPerformanceMetricsInfo = state =>
  getPerformanceMetricsPage(state).performanceMetricsInfo ||
   initialState.performanceMetricsInfo;
export const getPerformanceMetricsOutliersShown = state =>
  getPerformanceMetricsInfo(state).toggles & PERFORMANCE_METRICS_TOGGLES.OUTLIER;
export const getPerformanceSelectedJobs = state =>
  getPerformanceMetricsPage(state).selectedJobs;


// WEBPACK FOOTER //
// src/reducers/performanceMetricsPage.js